/* eslint-disable react-hooks/set-state-in-effect */
import { Info } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cachedGuidance = null;

export default function FieldGuide({ field }) {
  const [g, setG] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (cachedGuidance) {
      setG(cachedGuidance[field] || null);
      return;
    }

    api.get("/guidance").then((r) => {
      cachedGuidance = r.data;
      setG(r.data[field] || null);
    });
  }, [field]);

  if (!g) return null;

  return (
    <span className="relative inline-flex">
      <button
        type="button"
        data-testid={`guide-${field}`}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        className="theme-ink-dim hover:text-gold transition-colors"
        aria-label={`Help for ${g.label}`}
      >
        <Info size={12} weight="fill" />
      </button>
      {open && (
        <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-30 w-72 theme-surface border theme-border p-3 rounded-sm shadow-xl text-left pointer-events-none">
          <span className="block overline mb-1">{g.label}</span>
          <span className="block text-xs theme-ink-muted leading-relaxed">{g.help}</span>
          {g.example && (
            <span className="block text-[11px] theme-ink-dim mt-2 font-mono-data">e.g. {g.example}</span>
          )}
        </span>
      )}
    </span>
  );
}
